import type { ButtonHTMLAttributes, ReactNode } from "react";
import { ArrowUpDown } from "lucide-react";
import { dashboardDataTable } from "../DashboardDataTable/dashboardDataTableClasses";

export const DASHBOARD_TABLE_SORT_ICON_SIZE = 14;

type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type" | "children"> & {
  children: ReactNode;
};

/**
 * Standard sortable column header control (Meta Ads report): label + ⇅ icon.
 */
export function DashboardDataTableSortButton({
  children,
  className = "",
  ...rest
}: Props) {
  return (
    <button
      type="button"
      className={`${dashboardDataTable.sort} ${className}`.trim()}
      {...rest}
    >
      {children}
      <ArrowUpDown size={DASHBOARD_TABLE_SORT_ICON_SIZE} aria-hidden />
    </button>
  );
}
